import { programsFeature, programsActions } from './../store/programs.era';
import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';
import { Subject } from 'rxjs';
import { ErrorStreamChange} from '../models/$error.model';
import { EventStreamChange} from '../models/$event.model';
import { Session, ProgramDay } from '../store/programs.era';
import { LogService} from '../services/log.service';
import { TimeHelper } from 'globals/helpers/time.helper';
import { extractPropValuesAsSet, copyTitle, loadLocal, saveLocal, subTilDestroy } from './../helpers/helpers';
import { takeUntil, tap, take, first } from 'rxjs/operators';
import {formatDate} from "@angular/common";
import { Store, select } from '@ngrx/store';
import { programsArray } from 'src/app/store/reselectors/programs.reselector';
import { Dictionary, Update } from '@ngrx/entity';
import { environment } from '../../../src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Transitions, OnReset } from './transition.service.helpers';
import { createProgramFoundation, getProgramDates, initDay, initSession, ProgramLaneInitDayData, SessionInfo, SessionType, Setup, standardizeProgram, TimeZoneDetails, updateSessionTimesInPlace } from 'globals/store/programs.data';
import { eventsActions, eventsFeature } from '../store/events.era';
import { JoiEvent } from 'globals/store/events.data';
import { DecircularService } from './decircular.service';
import { Exhibitor, ExhibitorStand } from 'globals/store/exhibitors.data';
import { exhibitorToStand } from '../modules/program/program.helpers';
import { Program } from 'globals/store/programs.data';
import { InputEditorDialogComponent, InputEditorDialogData } from '../components/wizards/input-editor-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { openDialogGetResult } from '../helpers/angular-helpers';
import { collection, collectionChanges, deleteDoc, doc, DocumentChange, Firestore, orderBy, query, QuerySnapshot, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { FireHelper } from './helpers/fire.helper';
import { createId, getDefaultTimeZoneDetails, jsonCopyObject, simpleHasher, unknownDateToDate, updateProgramsToNewVenueStructureAndExtractOldVenues } from 'globals/helpers/helpers';
import { permissionsFeature } from '../store/permissions.era';

@Injectable({ providedIn: 'root'})
export class ProgramService implements OnReset {


    readonly api = `${environment.functionsURL}api/app`;
    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();
    public PROGRAM_LOADED = 'program_loaded'; // should delete
    public SPECIAL_PROGRAM_LOAD = 'special_program'; // should delete
    public FOCUS_ON_TIME = 'focus_on_time'; // should delete
    public $destroy: Subject<boolean> = new Subject();
    public _new_programs_eventId;
    public program_legend = {};
    public _file = 'program.service';
    public next_order_number = 0;
    public ids:string[] = [];
    public programs:Program[] = []
    public getDefaultTimeZoneDetails: (numberOfDays?:number) => TimeZoneDetails = getDefaultTimeZoneDetails;
    public defaultTimeZoneId: string
    private usedVenueIds: Set<string>
    public $destroy_programs: Subject<boolean> = new Subject();
    public _event: JoiEvent
    public _date_arr: string[]
    public timeHelper: TimeHelper = new TimeHelper();

     // should delete
    public content_view: any = {};
    public filtered_by: any = {};
    public onsite_date_idx = -1;
    private _is_program_team:boolean
    public sessionDescriptionHashes: Dictionary<number> = {}
    private envInjector = inject(Injector);

    constructor(
      private helper: FireHelper,
      public log: LogService,
      private db: Firestore,
      private http:HttpClient,
      public store: Store,
      private decircularService: DecircularService,
    ) {
      subTilDestroy(this, select(eventsFeature.selectEvent), '_event')
      subTilDestroy(this, select(programsFeature.selectDate_arr), '_date_arr')
      this.store.pipe(select(programsArray)).subscribe(programs=> this.programs=JSON.parse(JSON.stringify(programs)))
      this.store.pipe(select(permissionsFeature.selectAccess)).subscribe(access=>{
        this._is_program_team = access.types.includes('program');
      })
      const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.defaultTimeZoneId = timeZoneId
    }


    // ngOnDestroy() {
    //   this.$destroy.next(); this.$destroy.complete();
    // }
    onReset(resetType, value = null) {
      switch (resetType) {

        case Transitions.OnEnterEvent:
          // console.log('subscribing to programs...')
          const event = value as JoiEvent
          this.usedVenueIds = new Set(Object.keys(event.venues || {}))
          return this.getPrograms(event.eventId)
        
        case Transitions.OnExitEvent:
          // console.log('destroying programs...')
          return this.$destroy_programs.next(true)

        case Transitions.OnExitUser:
          // console.log('destroying programs...')
          return this.$destroy_programs.next(true)

        default:
          break;
      }
    }

/*     async getProgramsFromOutsideEvent(eventId: string) {
      this.store.dispatch(new ClearPrograms());
      this.$destroy_programs.next()
      await this.getPrograms(eventId)
    } */

    async getPrograms(eventId): Promise<boolean> { // returns true the first time they are loaded for delaying in opening manage task from all tasks / dashboard
      let loaded = false
      console.log('getPrograms');
      return new Promise((resolve, reject) => {
        this._new_programs_eventId = eventId
        console.log({_new_programs_eventId: this._new_programs_eventId})
        const q = query(collection(this.db, `programs`), where('eventId', '==', eventId), orderBy('order'));
        runInInjectionContext(this.envInjector, () => {
          collectionChanges(q).pipe(
            tap((changes:DocumentChange<Program>[])=> {
              this.handleProgramChangesFromDB(changes)
              if (!loaded) resolve(true)
              loaded = true
            }, response=>this.log.error({file:this._file, function:'getPrograms',response,error:new Error()})
            ),
            takeUntil(this.$destroy_programs)
          ).subscribe()})
      })
    }

    initializeProgramFromChangeAction(changeAction: DocumentChange<Program>): Program {
      const program: Program = changeAction.doc.data();
      console.log({program})
      // need to "fix" the program sessions here.  Putting the updates in every update function is pretty ridiculous
      Object.values(program.sessions_obj).forEach((s: Session) => this.sessionDescriptionHashes[s.id] = simpleHasher(s.id + JSON.stringify(s.description || '')))

      return standardizeProgram(program)
    }  
    
    handleProgramChangesFromDB(changes:DocumentChange<Program>[]){
      console.log('program changes from db', { changes })
      if(changes.length === 0){
        this.store.dispatch(programsActions.programSuccess())
      }

      const programsToAdd = changes.filter(c=> c.type === 'added').map(change=> this.initializeProgramFromChangeAction(change))
      const venuesToAdd = updateProgramsToNewVenueStructureAndExtractOldVenues(this.usedVenueIds, programsToAdd, this.defaultTimeZoneId)

      const programsToModify: Program[] = changes.filter(c=>c.type === 'modified').map(change=>this.initializeProgramFromChangeAction(change))
      const programsToRemove:DocumentChange<Program>[] = changes.filter(c=>c.type === 'removed')


      if (programsToAdd.length > 1) {
        this.store.dispatch(programsActions.addManyPrograms(programsToAdd))
      }else if(programsToAdd.length === 1){
        const added:Program = programsToAdd[0];
        this.store.dispatch(programsActions.addOneProgram(added))
      }

      if(programsToModify.length > 1){
        const updatePrograms:Update<Program>[] = programsToModify.map(p=>({id:p.id, changes:p}))
        this.store.dispatch(programsActions.modifyManyPrograms(updatePrograms))
      }else if(programsToModify.length === 1){
        const modified:Program = programsToModify[0];
        this.store.dispatch(programsActions.modifyProgram(modified.id, modified))
      }

      programsToRemove.forEach(change=>{
        this.store.dispatch(programsActions.removeProgram(change.doc.id));
      })
      if (venuesToAdd.length) this.store.dispatch(eventsActions.updateEventVenues(venuesToAdd))
      if (this._event) this.storeProgramDates() // can be hit from outside of an event (view event dialog), causing errors
      this.setNewProgramInfo()
    }


    /*
    sets this.next_order_number and fires this.FOCUS_ON_TIME
    */
    setNewProgramInfo(from_event?:string){
        this.program_legend = {};
        for (let i = 0; i < this.programs.length; i++) {
            this.content_view[this.programs[i].id + '_program_info'] = 'expand'; // fix add after reorder bug
            this.program_legend[this.programs[i].id] = i;
            if(this.programs[i].order + 1 >= this.next_order_number) this.next_order_number = Math.floor(this.programs[i].order) + 1;
        }
        this.store.pipe(select(programsFeature.selectNew_day_added), take(1)).subscribe(new_day_added=>{
          if(!new_day_added || new_day_added.program_idx === undefined) return;
          const idx = new_day_added.program_idx
          if(idx !== undefined) this.store.dispatch(programsActions.programSessionDayAdded({program_idx:idx, program_displaying:true}))
        })
    }

    getProgramPromise(programId: string): Promise<Program> {
      return new Promise((resolve,_) => this.store.pipe(select( programsFeature.selectEntities), first()).subscribe(programEntities => resolve(programEntities[programId])))
    }

    deleteSession(programId: string, session: Session) {
      const program = this.programs.find(p => p.id === programId)
      console.log({ programs: this.programs, program, session })
      const daySessionIds = program.sessions.find(day => day.sessions.includes(session.id)).sessions
      daySessionIds.splice(daySessionIds.indexOf(session.id), 1)
      delete program.sessions_obj[session.id]
      this.upsertProgram(program)
    }


    duplicateSession(programId: string, session: Session) {
      const dup_session = jsonCopyObject(session)
      const program = this.programs.find(p => p.id === programId)
      const dup_id = program.id + '_' + program.id_seed++
      dup_session.id = dup_id
      dup_session.title = copyTitle(dup_session.title, Object.values(program.sessions_obj).map((s: Session) => s.title))
      const daySessionIds = program.sessions.find(day => day.sessions.includes(session.id)).sessions
      daySessionIds.splice(daySessionIds.indexOf(session.id) + 1, 0, dup_id)
      program.sessions_obj[dup_id] = dup_session

      this.updateSessionTimes(program)
      this.upsertProgram(program)
    }

    updateSessionLabels(sessionId: string, programId: string, labels: string[]) {
      this.getProgramPromise(programId).then(program => {
        program.sessions_obj[sessionId].labels = labels
        this.upsertProgram(program)
      })
    }

    

    addEntityToMultipleSessions<K extends { [P in keyof Session]: Session[P] extends string[] ? P : never }[keyof Session],  M extends { [P in keyof Session]: Session[P] extends Record<string, string> ? P : never }[keyof Session]>(sessions: SessionInfo[], entityId: string, idArrayKey: K, statusMapKey: M, defaultStatus: string): void {
      const programIds = extractPropValuesAsSet<string, SessionInfo>(sessions, 'programId')
      programIds.forEach(programId => {
        this.getProgramPromise(programId).then(passedProgram => {
          const program = jsonCopyObject(passedProgram);
          sessions.filter(s => s.programId === programId).forEach(({ id }) => {
            const session = (program.sessions_obj[id])
            if (!session[idArrayKey]) session[idArrayKey] = []
            session[idArrayKey].push(entityId)

            if (!session[statusMapKey]) session[statusMapKey] = {};
            (session[statusMapKey] as Record<string, string>)[entityId] = defaultStatus
            })
          this.upsertProgram(program)
        })
      })
    }

    tagEntityToMultipleSessions<K extends keyof Session>(sessions: SessionInfo[], entityId: string, idArrayKey: K extends K ? Session[K] extends string[] ? K : never : never): void {
      const programIds = extractPropValuesAsSet<string, SessionInfo>(sessions, 'programId')
      programIds.forEach(programId => {
        this.getProgramPromise(programId).then(program => {
          sessions.filter(s => s.programId === programId).forEach(({ id }) => {
            const session = program.sessions_obj[id]
            if (!session[idArrayKey]) session[idArrayKey] = []
            session[idArrayKey].push(entityId)
            })
          this.upsertProgram(program)
        })
      })
    }

    storeProgramDates(changed_by_user?:boolean, by_pass_matching_check?:boolean){
      const old_date_arr = this._date_arr
      const date_arr = getProgramDates(this.programs)
      if(by_pass_matching_check || !old_date_arr || jsonCopyObject(old_date_arr) !== jsonCopyObject(date_arr)) {
        this.store.dispatch(programsActions.programDatesChanged(date_arr, changed_by_user))
        this.decircularService.saveEventDays(this._event, date_arr)
        this.store.dispatch(programsActions.programDatesUpdatedToMatchEventDates())
      }
    }

    // these are used for the on drop event
    getProgram(programId: string) {
        if(!this.program_legend) return;
        return this.programs[this.program_legend[programId.split('-')[0]]];
    }

    initDay(program: Program): ProgramLaneInitDayData {
      return initDay(program)
    }

    initSession(program, type: SessionType = 'session'): Session {
      return initSession(program, type)
    }

    setupProgram(program: Partial<Program>, renameSessions: boolean = false, importedSessions: Partial<Session>[] = null): Program {
      return createProgramFoundation(program, renameSessions, this._new_programs_eventId, this.next_order_number, getDefaultTimeZoneDetails(), createId(), importedSessions)
    }

    async duplicateProgram(program:Program): Promise<string> {

        // console.log('old program ',program)
        let new_program = JSON.parse(JSON.stringify(program));
        delete new_program.id;
        delete new_program.id_seed;
        new_program.title = copyTitle(new_program.title, this.programs.map(p => p.title))
        new_program = this.setupProgram(new_program, true);
        this.programs.splice(this.programs.findIndex(p => p.id === program.id) + 1, 0, new_program)
        try {
          const newProgramOrder = this.programs.map(p => p.id)
          console.log({ newProgam: new_program, newProgramOrder })
          await this.upsertProgram(new_program, null, true)
          await this.updateProgramOrder(newProgramOrder)
          const oldVisiblePrograms = loadLocal(`${this._event.eventId}/visiblePrograms`)
          if (oldVisiblePrograms) {
            saveLocal(`${this._event.eventId}/visiblePrograms`, [...oldVisiblePrograms, new_program.id ])
          }
          return new_program.id
        } catch (error) {
          this.log.error({
            file:this._file, function:'duplicateProgram', response: error, message:'Duplication failed to save'
          })
          return null
        }
    }

    async parseSessionDurationAndSave(passedSession: Session, duration: unknown, programId: string) {
      const prog = this.programs[this.program_legend[programId.split('-')[0]]] || this.programs[this.program_legend[programId]]
      const session = {...passedSession}
      session.duration = parseFloat(duration as unknown as string) || 0;

      prog.sessions_obj[session.id] = session
      this.upsertProgram(prog)
    }

    async addProgram(program_start: Partial<Program>, importedSessions: Partial<Session>[] = null): Promise<string> {
      const new_program = this.setupProgram(program_start, false, importedSessions);
      this.updateProgramOrder([...this.programs.map(p => p.id), new_program.id ])
      await this.upsertProgram(new_program, {function:'addProgram'}, true)
        .catch(console.error)
        // console.log('made it to here')

      const oldVisiblePrograms = loadLocal(`${this._event.eventId}/visiblePrograms`)
      if (oldVisiblePrograms) {
        saveLocal(`${this._event.eventId}/visiblePrograms`, [...oldVisiblePrograms, new_program.id ])
      }
      this.storeProgramDates(true)
      // console.log('made it to there')
      return new_program.id
    }

    async addSetup(passedProgram: Program): Promise<string> {
      const program = jsonCopyObject(passedProgram);
      const id = createId()

      program.setupIds.push(id)
      program.setups[id] = {
        id,
        sessionIds: [],
        expected: null,
        capacity: null,
        clearDay: 0,
        accessDay: 0,
        name: `${program.title} setup ${program.setupIds.length}`,
        notes: [],
        setup: null,
        assetIds: []
      }
      const partialProgram = { setupIds: program.setupIds, setups: program.setups }
      console.log(partialProgram)
      await this.sendProgramUpdate(program.id, partialProgram, { file:this._file, function:'addSetup', data: partialProgram })
      return id
    }

    upsertProgram(program: Program, log_data?:Partial<ErrorStreamChange>, is_new_program?:boolean) {
      if (!program) throw new Error("Empty program sent to upsert program")
      if (typeof program === 'string') throw new Error("Program should not be string")
      program = this.updateSessionTimes(program)
      return this.sendProgramUpdate(program.id, program, log_data, is_new_program )
    }

    async editFacilitatorNotes({ event, programId, sessionId }: { event: Event, programId: string, sessionId?: string }, dialog: MatDialog) {
      const program = jsonCopyObject(this.programs.find(p => p.id === programId))
      const session = !sessionId ? null : program.sessions_obj[sessionId]
      const text = (session || program).facilitatorNotes
      const title = `Edit ${(session || program).title || ''} Facilitator Notes`
      const data: InputEditorDialogData = { text, title, placeholder: 'Facilitator Notes' }
  
      const result = await openDialogGetResult<InputEditorDialogData>(dialog, InputEditorDialogComponent, { width: '480px', disableClose: true, data })
  
      if (!result) return // cancelled
      if (result.text === text) return // no change

      if (sessionId) {
        program.sessions_obj[sessionId].facilitatorNotes = result.text
      } else {
        program.facilitatorNotes = result.text
      }

      await this.upsertProgram(program)
    }


    updateSession(programId, session: Session, file="", functionName = "") {
      this.sendProgramUpdate(programId,
        {['sessions_obj.'+session.id]: session },
        {message:"There was an error saving this session"},
        false
      )
    }

    updateSessionTitle(id:string, title:string, obj_id:string, session: Session = null){
      console.log({ id, title, session, obj_id });
      this.sendProgramUpdate(id,
        {['sessions_obj.'+obj_id+'.title']:title},
        {message:"There was an error saving this session title!"},
        false
      )
    }

    async updateManySessionLabels(labelUpdates: { [programId:string]: { sessionId: string, labels: string[] }[] }) {
      const updatePromises = []
      Object.entries(labelUpdates).forEach(([programId, sessionUpdates]) => {
        const updateObject = {}
        sessionUpdates.forEach(({ sessionId, labels }) => updateObject['sessions_obj.'+sessionId+'.labels'] = labels)
        const promise = this.sendProgramUpdate(programId, updateObject, {message:"There was an error saving the session labels"})
        updatePromises.push(promise)
      })
      await Promise.all(updatePromises)
    }

    updateSessionDescription(id:string, description:string, sessionId:string){
      // console.log({ id, description, obj_id });
      this.sendProgramUpdate(id,
        {['sessions_obj.'+sessionId+'.description']:description},
        {message:"There was an error saving this session description"},
        false
      )
    }

    updateProgramSetup(program: Program, setup: Setup) {
      const obj = program.setups ? jsonCopyObject({setups:program.setups}) : {setups: {}};
      obj.setups[setup.id] = setup;
      this.sendProgramUpdate(program.id, obj, { message: "There was an error updating the setup" })
    }

    updateProgramTitle(program:Program) {
      const {title} = program;
      this.sendProgramUpdate(program.id,
        {title},
        {message:"There was an error saving this program title"},
        false
      )
    }

    sendProgramUpdate(programId:string, update:Partial<Program>, log_data?:Partial<ErrorStreamChange>, is_new_program?:boolean):Promise<any>{
      const default_error_object = {
        file: this._file,
        function: 'sendProgramUpdate',
        error: new Error(),
        args: {programId, update}
      }
      console.log('is_new_program ', is_new_program, update);
      if(is_new_program){
        try {
          return setDoc(doc(this.db, 'programs', programId), update, { merge: true })
        } catch (response) {
          this.log.error({ response, ...default_error_object, ...log_data })
        }
      }else{ // this way dot notation will work
        // console.log('is_program_team', this._is_program_team)
        if(this._is_program_team){
          console.log({ update});
          try {
            updateDoc(doc(this.db, 'programs', programId), update);
          } catch (response) {
            this.log.error({ response, ...default_error_object, ...log_data })
          }
        }else{
          const url = `${this.api}/save-program-by-non-program-team-member`;
          return new Promise((resolve,reject)=>{
            this.http.post(url, {programId, update}).pipe(take(1)).subscribe((data:any)=>{
              resolve('Success');
            },response=>{
              this.log.error({file:this._file, function:'sendProgramUpdate api',response, message:'An error occured while updating the program details'})
              reject('Fail')
            })
          })
        }
      }
    }

    async deleteProgram(programId: string){
        // find the order of all the other programs and update them
        console.log("Should be deleting...", programId)
        await deleteDoc(doc(this.db, 'programs/'+programId))
        await this.updateProgramOrder(this.programs.map(p => p.id).filter(pId => pId !== programId))
        
        const oldVisiblePrograms = loadLocal(`${this._event.eventId}/visiblePrograms`)
        if (oldVisiblePrograms && oldVisiblePrograms.includes(programId)) {
          saveLocal(`${this._event.eventId}/visiblePrograms`, oldVisiblePrograms.filter(pId => pId !== programId))
        }

        this.storeProgramDates(true)
    }

    batchUpdateProgram(programs: Array<Program>, is_new_ids:string[] = []) {
      const valid_programs = [];
      const program_ids = [];
      this.next_order_number = 0;
      // console.log({ programs});
      programs.forEach((prog, i)=>{
        const program = this.updateSessionTimes(prog);
        // console.log({ program});
        if(program.id){
          if(program_ids.indexOf(program.id) === -1){
            valid_programs.push({ref: 'programs/' + program.id, data: program, is_new:is_new_ids.includes(program.id)});
            program_ids.push(program.id)
            this.program_legend[this.programs[i].id] = i;
            if(this.programs[i].order + 1 >= this.next_order_number) this.next_order_number = Math.floor(this.programs[i].order) + 1;
          // }else{
            // this.programs.splice(program.order, 1);
          }
        }
      })
      return this.helper.batchUpdate(valid_programs)
      //
    }
    /**
     *
     * @param updated_programs_copy dragula event model
     * @param inserted_program_id sent from duplicate program so that it can be set as the new day
     */
    async updateProgramOrder(programOrder: string[]): Promise<void> {
      console.log('Update program order called', { programOrder: jsonCopyObject(programOrder) })
      await this.decircularService.updateEvent(this._event.eventId, { programOrder })
    }

  updateSessionTimes(program: Program): Program {
    updateSessionTimesInPlace(program)
    return program
  }

    getSessionsInDay(program, idx){
        let num_following = 0;
        if(!program.sessions[idx] || program.sessions[idx].type !== 'day') return num_following;
        for (let i = 0; i < program.sessions.length; i++) {
            if(i > idx){
                if(program.sessions[i].type === 'day') break;
                num_following++;
            }
        }
        return num_following;
    }

    hasSubsequentDays(program, idx){
        if(!program.sessions[idx]) return false;
        for (let i = 0; i < program.sessions.length; i++) {
            if(i > idx){
                if(program.sessions[i].type === 'day') return true;
            }
        }
        return false;
    }

    deleteProgramsByEventId(eventId){
        // const query = this.helper.buildQuery([['where', 'eventId', '==', eventId]]);
        const deleted = this.helper.batchDeleteWhere( `programs`, [['eventId', '==', eventId]]);
    }

    dateID(d: any): string {
      if (!d) { return ''; }
      if (typeof d === 'string') {
          return d.replace(' ', '');
      } else {
        return formatDate(unknownDateToDate(d), 'yyyyMMdd', 'en-au');
      }
    }
  



}
